
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4F71E8","d":"M2.605 0h15.058s.683.005 1.183.177c.481.165.824.416.824.416l.003.002 7.681 6.525s.34.287.505.582c.133.238.141.674.141.674a.39.39 0 00-.001.022v17.518c0 1.163-1.15 2.084-2.605 2.084H2.604C1.15 28 0 27.08 0 25.916V2.084C0 .92 1.15 0 2.605 0z"}}),_c('path',{attrs:{"fill":"#fff","fill-rule":"evenodd","d":"M14.707 17.586L18 14.293l1.414 1.414-5.707 5.707L8 15.707l1.414-1.414 3.293 3.293V7h2v10.586z","clip-rule":"evenodd"}})])
          )
        }
      }
    